module.exports = require("@splunk/react-ui/Markdown");